module.exports = __webpack_public_path__ + "img/gras.f15eca04.jpg";